import { InteractionType, EventSource, MixpanelEvent, ComponentType } from '../MixPanelTypes';

export type TaskEvents =
  | 'ACTION_APPROVE_TASK'
  | 'ACTION_REJECT_TASK'
  | 'ACTION_CANCEL_TASK'
  | 'ACTION_DELEGATE_TASK'
  | 'ACTION_DELETE_TASK_DELEGATION'
  | 'ACTION_TERMINATE_PROCESS'
  | 'ACTION_DELETE_PROCESS'
  | 'ACTION_DELETE_JOB_POSTING';

export const taskEvents: Record<TaskEvents, MixpanelEvent> = {
  ACTION_APPROVE_TASK: {
    eventKey: 'task-action-approve',
    eventDescription: 'Task Action - Approve',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  ACTION_REJECT_TASK: {
    eventKey: 'task-action-reject',
    eventDescription: 'Task Action - Reject',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  ACTION_CANCEL_TASK: {
    eventKey: 'task-action-cancel',
    eventDescription: 'Task Action - Cancel',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  ACTION_DELEGATE_TASK: {
    eventKey: 'task-action-delegate',
    eventDescription: 'Task Action - Delegate',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  ACTION_DELETE_TASK_DELEGATION: {
    eventKey: 'task-action-delete-task-delegation',
    eventDescription: 'Task Action - Delete Task Delegation',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  ACTION_TERMINATE_PROCESS: {
    eventKey: 'task-action-terminate-process',
    eventDescription: 'Task Action - Terminate Process',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  ACTION_DELETE_PROCESS: {
    eventKey: 'task-action-delete-process',
    eventDescription: 'Task Action - Delete Process',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  ACTION_DELETE_JOB_POSTING: {
    eventKey: 'task-action-delete-job-posting',
    eventDescription: 'Task Action - Delete Job Posting',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  }
} as const;
